module.exports = __webpack_public_path__ + "static/03-610cadc892eafc7f5b1d8c5755e08348.jpg";